export default __webpack_public_path__ + "static/media/info-white.c660de25.svg";